/* eslint-disable jsx-a11y/alt-text */
import "./Certificates.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import Codewars from "../../../../Images/codewars.svg";
export default function Certificates() {
  useEffect(() => {
    Aos.init({
      once: true,
      duration: 1500,
    });
  }, []);
  return (
    <div className="certificates mt-60" data-aos="zoom-in" id="certs">
      <div className="sub-title text-center text-5xl lg:text-7xl mb-10 ">
        Certificates
      </div>
      <div className="hr w-2/3"></div>

      <div className="cert-content flex flex-col lg:flex-row w-full lg:w-2/3 px-3 mx-auto space-x-0 lg:space-x-20">
        <div className="cert-desc shrink grow basis-0 mb-10  w-full md:w-2/3 lg:w-full mx-auto lg:mx-0">
          <p className="cert-desc-text leading-8 text-justify">
            Here you can see my certificates and profiles for each programming
            websites. You can see how much knowladge I got by now. I tried so
            many <b>platforms</b> to improve my coding, programming skill. Now I
            am able to use those of skills to get paid. I am happy to spent so
            many years struggoling on some wierdo hard coding questions.
          </p>
        </div>
        <div className="cert-l shrink grow basis-0">
          <p className="text-3xl font-semibold mb-2 text-center lg:text-left">
            <img
              className="hrk pr-2"
              src="https://img.icons8.com/external-tal-revivo-shadow-tal-revivo/36/000000/external-hackerrank-is-a-technology-company-that-focuses-on-competitive-programming-logo-shadow-tal-revivo.png"
            />
            Hackerrank
          </p>
          <ul className="mt-5 grid grid-cols-2 w-fit mx-auto">
            <li className="pl-3 text text-xl flex-r"> - C# (Basic) </li>
            <a
              className="text-orange-500 underline ml-10"
              href="https://www.hackerrank.com/certificates/e0a4523a8874"
            >
              View certiciate
            </a>
            <li className="pl-3 text text-xl"> - Python3 (Basic)</li>
            <a
              className="text-orange-500 underline ml-10"
              href="
						https://www.hackerrank.com/certificates/c0be3701d791"
            >
              View certiciate
            </a>
            <li className="pl-3 text text-xl"> - Problem Solving (Basic)</li>
            <a
              className="text-orange-500 underline ml-10"
              href="https://www.hackerrank.com/certificates/5b3bfbc26dc8"
            >
              View certiciate
            </a>
            <li className="pl-3 text text-xl"> - Javascript (Basic)</li>{" "}
            <a
              className="text-orange-500 underline ml-10"
              href="https://www.hackerrank.com/certificates/3a3ff755b157"
            >
              View certiciate
            </a>
            <li className="pl-3 text text-xl"> - React(Basic)</li>{" "}
            <a
              className="text-orange-500 underline ml-10"
              href="https://www.hackerrank.com/certificates/5039b882f8d5"
            >
              View certiciate
            </a>
          </ul>
          <p className="text-3xl mt-10 font-semibold mb-2 text-center lg:text-left">
            <img className="cdw mr-2" src={Codewars} alt="" />
            CodeWars
          </p>
          <div className="mt-2 grid grid cols-2 w-fit mx-auto lg:mx-0 mb-5">
            <img
              src="https://www.codewars.com/users/molesz/badges/large"
              alt=""
            />
          </div>
          <p>
            <img src="https://img.icons8.com/external-justicon-flat-justicon/36/000000/external-linkedin-social-media-justicon-flat-justicon.png" />
            Linkedin
          </p>
		  <ul className="mt-5 grid grid-cols-2 w-fit mx-auto">
            <li className="pl-3 text text-xl flex-r"> - Python (Programming Language) </li>
            <a
              className="text-orange-500 underline ml-10"
              href="https://www.linkedin.com/feed/update/urn:li:activity:6921738733633294337/"
            >
              View certiciate
            </a>
			<li className="pl-3 text text-xl flex-r"> - Front-End Development </li>
            <a
              className="text-orange-500 underline ml-10"
              href="https://www.linkedin.com/feed/update/urn:li:activity:6921738531409137664/"
            >
              View certiciate
            </a>
		  </ul>
        </div>
      </div>
    </div>
  );
}
